import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { humanReadable } from "../utils/useWindowDimensions";
import moment from "moment";
import { DownIcon, UpDownIcon, UpIcon } from "../Assets/iconshere";
import ReactPaginate from "react-paginate";
import useWindowDimensions from "../utils/useWindowDimensions";

const TeamEngagementTable = ({
  type,
  list,
  loading,
  visitType,
  setPage,
  page,
  limit,
  pageCount,
  sortBy,
  setSortBy,
}) => {
  const startIndex = Math.min(page * limit + 1, pageCount);
  const endIndex = Math.min((page + 1) * limit, list.length);
  const displayStart = startIndex;
  const displayEnd = startIndex + endIndex - 1;
  const [sortOrder, setSortOrder] = useState("asc");

  const handlePageClick = ({ selected }) => {
    setPage(selected);
  };

  const handleSort = (key) => {
    if (sortBy === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(key);
      setSortOrder("asc");
    }
  };

  const sortedList = list.slice().sort((a, b) => {
    if (type === "visits") {
      if (visitType === "total") {
        if (sortBy === "name") {
          return sortOrder === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        } else if (sortBy === "timestamp") {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
        } else if (sortBy === "timeSpent") {
          return sortOrder === "asc" ? a.time - b.time : b.time - a.time;
        }
      } else {
        if (sortBy === "name") {
          return sortOrder === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
        } else if (sortBy === "visitCount") {
          return sortOrder === "asc" ? a.sessionCount - b.sessionCount : b.sessionCount - a.sessionCount;
        } else if (sortBy === "totaltimeSpent") {
          return sortOrder === "asc"
            ? a.durations.totalTime - b.durations.totalTime
            : b.durations.totalTime - a.durations.totalTime;
        } else if (sortBy === "avgtimeSpent") {
          return sortOrder === "asc"
            ? a.durations.averageTime - b.durations.averageTime
            : b.durations.averageTime - a.durations.averageTime;
        }
      }
    } else if (type === "eventsList") {
      if (sortBy === "eventName") {
        return sortOrder === "asc" ? a.eventName.localeCompare(b.eventName) : b.eventName.localeCompare(a.eventName);
      } else if (sortBy === "date") {
        return sortOrder === "asc" ? new Date(a.date) - new Date(b.date) : new Date(b.date) - new Date(a.date);
      } else if (sortBy === "eventDuration") {
        return sortOrder === "asc" ? a.actualEventTime - b.actualEventTime : b.actualEventTime - a.actualEventTime;
      } else if (sortBy === "actualTimeSpent") {
        return sortOrder === "asc" ? a.activityDuration - b.activityDuration : b.activityDuration - a.activityDuration;
      }
    } else if (type === "session") {
      if (sortBy === "name") {
        return sortOrder === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
      } else if (sortBy === "sessionCount") {
        return sortOrder === "asc" ? a.sessionCount - b.sessionCount : b.sessionCount - a.sessionCount;
      } else if (sortBy === "totalTime") {
        return sortOrder === "asc"
          ? a.durations.totalTime - b.durations.totalTime
          : b.durations.totalTime - a.durations.totalTime;
      } else if (sortBy === "averageTime") {
        return sortOrder === "asc"
          ? a.durations.averageTime - b.durations.averageTime
          : b.durations.averageTime - a.durations.averageTime;
      }
    }

    return 0;
  });

  return (
    <>
      {type === "visits" && (
        <>
          {visitType === "total" ? (
            <>
              <div className="stickyhead reports">
                <table className="table withsort align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th className="text-start">
                        <span
                          onClick={() => handleSort("name")}
                          className="d-flex align-items-center justify-content-start gap-2 sort"
                        >
                          Name
                          {sortBy === "name" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                        </span>
                      </th>
                      <th>
                        <span
                          onClick={() => handleSort("timestamp")}
                          className="d-flex align-items-center justify-content-center gap-2 sort"
                        >
                          Timestamp
                          {sortBy === "timestamp" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                        </span>
                      </th>
                      <th>Platform</th>
                      <th onClick={() => handleSort("timeSpent")}>
                        <span className="d-flex align-items-center justify-content-center gap-2 sort">
                          Time Spent
                          {sortBy === "timeSpent" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading ? (
                      <>
                        {sortedList.map((e, i) => (
                          <tr key={i + 1}>
                            <td>{i + 1 + page * limit}</td>
                            <td className="nameimage">
                              {e.avatar ? (
                                <img src={e.avatar} referrerPolicy="no-referrer" alt="" />
                              ) : (
                                <div className="initials-placeholder">
                                  {e?.name &&
                                    e.name
                                      .split(" ")
                                      .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                      .join("")
                                      .toUpperCase()}
                                </div>
                              )}
                              {e.name}
                            </td>
                            <td>{moment(e.date).format("LLL")}</td>
                            <td>{e.platform}</td>
                            <td>{humanReadable(e.time)}</td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        {[...Array(6)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <Skeleton width="3vw" />
                            </td>
                            <td className="nameimage">
                              <Skeleton count={1} circle height="35px" width="35px" className="me-3" />
                              <Skeleton width="5vw" />
                            </td>
                            <td>
                              <Skeleton width="5vw" />
                            </td>
                            <td>
                              <Skeleton width="5vw" />
                            </td>
                            <td>
                              <Skeleton width="5vw" />
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row w-100 pb-3 ms-1">
                {pageCount > 0 && (
                  <div className="col-lg-6 ps-0 d-flex align-items-center justify-content-start">
                    <span className="page-num">
                      Showing{" "}
                      <span className="ps-1 pe-1">
                        {displayStart} - {displayEnd}
                      </span>{" "}
                      of <span className="ps-1">{pageCount}</span>
                    </span>
                  </div>
                )}
                <div className="col-lg-6 d-flex align-items-center justify-content-end">
                  <ReactPaginate
                    pageCount={Math.ceil(pageCount / limit)}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    onPageChange={handlePageClick}
                    previousLabel="<"
                    nextLabel=">"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item-pre"
                    previousLinkClassName="page-link"
                    nextClassName="page-item-next"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={page}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="stickyhead reports">
                <table className="table withsort align-middle table-nowrap mb-0">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th className="text-start">
                        <span className="d-flex align-items-center justify-content-start gap-2 sort">
                          Name
                          <span onClick={() => handleSort("name")}>
                            {sortBy === "name" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                          </span>
                        </span>
                      </th>
                      <th>
                        <span className="d-flex align-items-center justify-content-center gap-2 sort">
                          Count
                          <span onClick={() => handleSort("visitCount")}>
                            {sortBy === "visitCount" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                          </span>
                        </span>
                      </th>
                      <th>
                        <span className="d-flex align-items-center justify-content-center gap-2 sort">
                          Total Time Spent
                          <span onClick={() => handleSort("totaltimeSpent")}>
                            {sortBy === "totaltimeSpent" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                          </span>
                        </span>
                      </th>
                      <th>
                        <span className="d-flex align-items-center justify-content-center gap-2 sort">
                          Average Time Spent
                          <span onClick={() => handleSort("avgtimeSpent")}>
                            {sortBy === "avgtimeSpent" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                          </span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!loading ? (
                      <>
                        {sortedList.length > 0 &&
                          sortedList.map((e, i) => (
                            <tr key={i + 1}>
                              <td>{i + 1 + page * limit}</td>
                              <td className="nameimage">
                                {e.avatar ? (
                                  <img src={e.avatar} referrerPolicy="no-referrer" alt="" />
                                ) : (
                                  <div className="initials-placeholder">
                                    {e?.name &&
                                      e.name
                                        .split(" ")
                                        .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                        .join("")
                                        .toUpperCase()}
                                  </div>
                                )}
                                {e.name}
                              </td>
                              <td>{e.sessionCount}</td>
                              <td>{e.durations.totalTime && humanReadable(e.durations.totalTime)}</td>
                              <td>{e.durations.averageTime && humanReadable(e.durations.averageTime)}</td>
                            </tr>
                          ))}
                      </>
                    ) : (
                      <>
                        {[...Array(6)].map((_, index) => (
                          <tr key={index}>
                            <td>
                              <Skeleton width="3vw" />
                            </td>
                            <td className="nameimage">
                              <Skeleton count={1} circle height="35px" width="35px" className="me-3" />
                              <Skeleton width="5vw" />
                            </td>
                            <td>
                              <Skeleton width="5vw" />
                            </td>
                            <td>
                              <Skeleton width="5vw" />
                            </td>
                            <td>
                              <Skeleton width="5vw" />
                            </td>
                          </tr>
                        ))}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row w-100 pb-3 ms-1">
                {pageCount > 0 && (
                  <div className="col-lg-6 ps-0 d-flex align-items-center justify-content-start">
                    <span className="page-num">
                      Showing{" "}
                      <span className="ps-1 pe-1">
                        {displayStart} - {displayEnd}
                      </span>{" "}
                      of <span className="ps-1">{pageCount}</span>
                    </span>
                  </div>
                )}
                <div className="col-lg-6 d-flex align-items-center justify-content-end">
                  <ReactPaginate
                    pageCount={Math.ceil(pageCount / limit)}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    onPageChange={handlePageClick}
                    previousLabel="<"
                    nextLabel=">"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item-pre"
                    previousLinkClassName="page-link"
                    nextClassName="page-item-next"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={page}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}

      {type === "eventsList" && (
        <>
          <div className="stickyhead reports">
            <table className="table withsort align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th> S.No </th>
                  <th className="text-start"> Event Name </th>
                  <th>Environment</th>
                  <th onClick={() => handleSort("date")}>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">
                      Date
                      {sortBy === "date" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th onClick={() => handleSort("eventDuration")}>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">
                      Event Duration
                      {sortBy === "eventDuration" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th onClick={() => handleSort("actualTimeSpent")}>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">
                      Actual Time Spent
                      {sortBy === "actualTimeSpent" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  <>
                    {sortedList.map((e, i) => (
                      <tr key={i + 1}>
                        <td>{i + 1 + page * limit}</td>
                        <td className="nameimage">
                          {e.avatar ? (
                            <img src={e.avatar} referrerPolicy={"no-referrer"} alt="" />
                          ) : (
                            <div className="initials-placeholder">
                              {" "}
                              {e?.eventName &&
                                e.eventName
                                  .split(" ")
                                  .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                  .join("")
                                  .toUpperCase()}{" "}
                            </div>
                          )}
                          {e.eventName}
                        </td>
                        <td>{e.environmentName}</td>
                        <td>{moment(e.date).format("LLL")}</td>
                        <td>{humanReadable(e.actualEventTime)}</td>
                        <td>{humanReadable(e.activityDuration)}</td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <>
                    {[...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="3vw" />
                        </td>
                        <td className="nameimage">
                          <Skeleton count={1} circle height="35px" width="35px" className="me-3" />
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="row w-100 pb-3 ms-1">
            {pageCount > 0 && (
              <div className="col-lg-6 ps-0 d-flex align-items-center justify-content-start">
                <span className="page-num">
                  Showing{" "}
                  <span className="ps-1 pe-1">
                    {displayStart} - {displayEnd}
                  </span>{" "}
                  of <span className="ps-1">{pageCount}</span>
                </span>
              </div>
            )}
            <div className="col-lg-6 d-flex align-items-center justify-content-end">
              <ReactPaginate
                pageCount={Math.ceil(pageCount / limit)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                onPageChange={handlePageClick}
                previousLabel="<"
                nextLabel=">"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item-pre"
                previousLinkClassName="page-link"
                nextClassName="page-item-next"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                forcePage={page}
              />
            </div>
          </div>
        </>
      )}
      {type === "session" && (
        <>
          <div className="stickyhead reports">
            <table className="table withsort align-middle table-nowrap mb-0">
              <thead>
                <tr>
                  <th> S.No </th>
                  <th className="text-start">
                    <span
                      onClick={() => handleSort("name")}
                      className="d-flex align-items-center justify-content-start gap-2 sort"
                    >
                      Name
                      {sortBy === "name" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                    </span>
                  </th>
                  <th>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">
                      Total Sessions
                      <span onClick={() => handleSort("sessionCount")}>
                        {sortBy === "sessionCount" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">
                      Total Time Spent
                      <span onClick={() => handleSort("totalTime")}>
                        {sortBy === "totalTime" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                      </span>
                    </span>
                  </th>
                  <th>
                    <span className="d-flex align-items-center justify-content-center gap-2 sort">
                      Average Session Time
                      <span onClick={() => handleSort("averageTime")}>
                        {sortBy === "averageTime" && sortOrder === "asc" ? <DownIcon /> : <UpIcon />}
                      </span>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  <>
                    {sortedList.map((e, i) => (
                      <tr key={i + 1}>
                        <td>{i + 1 + page * limit}</td>
                        <td className="nameimage">
                          {e.avatar ? (
                            <img src={e.avatar} referrerPolicy={"no-referrer"} alt="" />
                          ) : (
                            <div className="initials-placeholder">
                              {e?.name &&
                                e.name
                                  .split(" ")
                                  .map((word, index) => (index === 0 || index === 1 ? word.charAt(0) : ""))
                                  .join("")
                                  .toUpperCase()}
                            </div>
                          )}
                          {e.name}
                        </td>
                        <td>{e.sessionCount}</td>
                        <td>{humanReadable(e.durations.totalTime)}</td>
                        <td>{humanReadable(e.durations.averageTime)}</td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <>
                    {[...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td>
                          <Skeleton width="3vw" />
                        </td>
                        <td className="nameimage">
                          <Skeleton count={1} circle height="35px" width="35px" className="me-3" />
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                        <td>
                          <Skeleton width="5vw" />
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className="row w-100 pb-3 ms-1">
            {pageCount > 0 && (
              <div className="col-lg-6 ps-0 d-flex align-items-center justify-content-start">
                <span className="page-num">
                  Showing{" "}
                  <span className="ps-1 pe-1">
                    {displayStart} - {displayEnd}
                  </span>{" "}
                  of <span className="ps-1">{pageCount}</span>
                </span>
              </div>
            )}
            <div className="col-lg-6 d-flex align-items-center justify-content-end">
              <ReactPaginate
                pageCount={Math.ceil(pageCount / limit)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                onPageChange={handlePageClick}
                previousLabel="<"
                nextLabel=">"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item-pre"
                previousLinkClassName="page-link"
                nextClassName="page-item-next"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                forcePage={page}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TeamEngagementTable;
